import { useState } from 'react';
import { copierTexte, ouvrirSms, ouvrirWhatsApp, partagerNatif, partageNatifDisponible } from '../api/partage.ts';

/** Bloc de partage : texte prêt à copier + boutons de partage (toujours déclenchés par l'utilisateur, jamais automatiques). */
export default function BlocPartage({ texte, titre, intitule = 'Texte à partager' }: { texte: string; titre: string; intitule?: string }) {
  const [info, setInfo] = useState<string | null>(null);
  return (
    <div className="carte">
      <h2>{intitule}</h2>
      <textarea readOnly value={texte} rows={Math.min(24, texte.split('\n').length + 1)} style={{ width: '100%', fontFamily: 'monospace' }} aria-label={intitule} onFocus={(e) => e.currentTarget.select()} />
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 8 }}>
        {partageNatifDisponible() && <button onClick={async () => setInfo((await partagerNatif(texte, titre)) ? 'Feuille de partage ouverte.' : null)}>📤 Partager…</button>}
        <button className="secondaire" onClick={() => ouvrirWhatsApp(texte)}>WhatsApp</button>
        <button className="secondaire" onClick={() => ouvrirSms(texte)}>SMS</button>
        <button className="secondaire" onClick={async () => setInfo((await copierTexte(texte)) ? 'Texte copié : collez-le dans votre messagerie.' : 'Copie impossible : sélectionnez le texte ci-dessus et copiez-le.')}>📋 Copier</button>
      </div>
      <p className="aide">Rien n'est envoyé automatiquement : vous choisissez le destinataire dans votre application de messagerie.</p>
      {info && <p role="status">{info}</p>}
    </div>
  );
}
